import React from 'react';
import 'antd/dist/antd.css';
import Routes from './routes';
import AuthProvider from './contexts/auth';
import FormProvider from './contexts/form';

function App() {
  return (
    <AuthProvider>
      <FormProvider>
        <Routes />
      </FormProvider>
    </AuthProvider>
  );
}

export default App;
